import { formateMonth } from '../utils/utils.js';
const mutations = {
    // 错误信息统一处理
    handleErrorMessage(state, errorMessage) {
        console.error(errorMessage);
        state.errorMessage = errorMessage;
        setTimeout(() => {
            state.errorMessage = '';
        }, 1000);
    },
    // 成功消息提醒
    handleSuccessMessage(state, successMessage) {
        state.successMessage = successMessage;
        setTimeout(() => {
            state.successMessage = '';
        }, 1000);
    },

    setUserInfo(state, userInfo) {
        state.userInfo = userInfo;
    },
    setIdolInfo(state, idolInfo) {
        state.idolInfo = idolInfo;
    },
    setScore(state, score) {
        state.score = score;
    },
    setProfit(state, profit) {
        state.profit = profit;
    },
    setUserProfit(state, userProfit) {
        state.property.balance = userProfit.surplusMoney;
        state.property.blocking = userProfit.frozenMoney;
        state.property.usable = userProfit.surplusMoney - userProfit.frozenMoney;
    },
    setNexus(state, nexus) {
        state.nexus = nexus;
    },
    setOpenid(state, openid) {
        state.openid = openid;
    },
    setSiteVersion(state, version) {
        state.version = version;
    },

    setPasswd(state, passwd) {
        state.passwd = passwd;
    },
    setUserName(state, userNameValue) {
        state.userInfo.nick = userNameValue;
    },
    setUserAvatar(state, userAvatar) {
        state.userInfo.headUrl = userAvatar;
    },
    editSign(state, signValue) {
        state.userInfo.sign = signValue;
    },
    setWxCode(state, wxCodePath) {
        state.userInfo.wxQrcodeCardUrl = wxCodePath;
    },
    setIncomeRetail(state, incomeRetail) {
        state.incomeRetail = incomeRetail;
    },
    setTotalIncomeRetail(state, incomeTotalRetail) {
        state.incomeTotalRetail = incomeTotalRetail;
    },
    setIncomeTeam(state, incomeTeam) {
        state.incomeTeam = incomeTeam;
    },
    setTotalIncomeTeam(state, incomeTotalTeam) {
        state.incomeTotalTeam = incomeTotalTeam;
    },
    setWithDrawList(state, withDrawList) {
        state.withDrawList = withDrawList;
    },
    setNexusRetailLevel(state, nexusRetailLevel) {
        state.nexusRetailLevelOverview = nexusRetailLevel.list;
        state.nexusRetailLevelUsers = nexusRetailLevel.users;
    },
    setNexusTeamLevel(state, nexusTeamLevel) {
        //因为返回的数据可能会出现中间断层的情况，这里把断层的节点去掉，
        // TODO 每次的名字还要优化一下，
        state.nexusTeamLevelOverview = nexusTeamLevel.list.filter((item)=> item.topScoreNode);
        state.nexusTeamLevelUsers = nexusTeamLevel.users;
    },
    setFansList(state, fansList) {
        state.fansList = fansList;
    },
    setTopProfit(state, topProfit) {
        state.topProfit = topProfit;
    },
    setQrocodes(state, qrocodes) {
        state.qrocodes = qrocodes;
    },
    setWxQrocode(state, wxCode) {
        if (state.qrocodes.find(s => s.payType === wxCode.payType)) {
            state.qrocodes = state.qrocodes.map(t => {
                if (t.payType === wxCode.payType) return wxCode;
                return t;
            });
            return;
        }
        state.qrocodes = state.qrocodes.concat(wxCode);
    },
    setAlipayQrocode(state, alipayCode) {
        if (state.qrocodes.find(s => s.payType === alipayCode.payType)) {
            state.qrocodes = state.qrocodes.map(t => {
                if (t.payType === alipayCode.payType) {
                    return alipayCode;
                }
                return t;
            });
            return;
        }
        state.qrocodes = state.qrocodes.concat(alipayCode);
    },
    setChannel(state, channelList) {
        // const blogChannelList = channelList.list.filter(s => s.channelType === 'blog');
        // const wxChannelList = channelList.list.filter(s => s.channelType !== 'blog');
        // let blogCount = 0;
        // blogChannelList.map(s => { blogCount = blogCount + channelList.overviews.find(t => t.channelKey === s.channelKey).all.count; });
        const axis = [];
        const value = [];
        channelList.list.map(s => {
            axis.push(s.name);
            value.push(channelList.overviews.find(t => t.channelKey === s.channelKey).all.count);
        });
        // axis.push('帖子');
        // value.push(blogCount);
        state.channel = { axis, value };
        state.channelList = channelList;
    },
    setFriendEnvPoster(state, data) {
        state.friendEnvPoster = data;
    },
    setFriendPoster(state, data) {
        state.friendPoster = data;
    },
    setOwnRank(state, data) {
        state.ownRank = data;
    },
    setFans(state, data) {
        const axis = [];
        const value = [];
        data.map(s => {
            axis.push(formateMonth(s.datePoint));
            value.push(s.count);
        });
        state.fans = { axis, value };
    },
    setFansSummary(state, data) {
        state.fansSummary = data;
    },
    setChannelEdit(state, id) {
        state.channelList = { ...state.channelList,
            list: state.channelList.list.map(s => {
                if (s.id === id) return { ...s, edit: true };
                return s;
        }) };
    },
    setBlur(state) {
        state.channelList = { ...state.channelList,
            list: state.channelList.list.map(s => {
                return { ...s, edit: false };
        }) };
    },
/*    setLoginConfig(state, loginConfig) {
        state.loginConfig = loginConfig.base;
    },*/
    setLoginCode(state, value) {
        state.getLoginCode = value;
    },
    login(state, value) {
        state.login = value;
    },
    setRightCode(state, value) {
      state.rightCode = value;
    },
    MEMBER_LEVEL_LIST(state, value) {
      state.memberLevelList = value;
    },

};
export default mutations;



// WEBPACK FOOTER //
// ./src/mutations/user.js